import { css } from 'styled-components'

const socialIcons = css`
    .ss-social,
    .ss-social:before,
    .ss-social.right:after {
        font-family: 'SSSocial';
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        text-rendering: optimizeLegibility;
        white-space: nowrap;
        -moz-font-feature-settings: 'liga=1';
        -moz-font-feature-settings: 'liga';
        -ms-font-feature-settings: 'liga' 1;
        -o-font-feature-settings: 'liga';
        font-feature-settings: 'liga';
        -webkit-font-smoothing: antialiased;
    }
    .ss-facebook:before,
    .ss-facebook.right:after {
        content: '';
    }
    .ss-twitter:before,
    .ss-twitter.right:after {
        content: '';
    }
    .ss-linkedin:before,
    .ss-linkedin.right:after {
        content: '';
    }
    .ss-googleplus:before,
    .ss-googleplus.right:after {
        content: '';
    }
    .ss-appdotnet:before,
    .ss-appdotnet.right:after {
        content: '';
    }
    .ss-zerply:before,
    .ss-zerply.right:after {
        content: '';
    }
    .ss-reddit:before,
    .ss-reddit.right:after {
        content: '';
    }
    .ss-tumblr:before,
    .ss-tumblr.right:after {
        content: '';
    }
    .ss-wordpress:before,
    .ss-wordpress.right:after {
        content: '';
    }
    .ss-blogger:before,
    .ss-blogger.right:after {
        content: '';
    }
    .ss-posterous:before,
    .ss-posterous.right:after {
        content: '';
    }
    .ss-youtube:before,
    .ss-youtube.right:after {
        content: '';
    }
    .ss-vimeo:before,
    .ss-vimeo.right:after {
        content: '';
    }
    .ss-flickr:before,
    .ss-flickr.right:after {
        content: '';
    }
    .ss-instagram:before,
    .ss-instagram.right:after {
        content: '';
    }
    .ss-fivehundredpx:before,
    .ss-fivehundredpx.right:after {
        content: '';
    }
    .ss-pinterest:before,
    .ss-pinterest.right:after {
        content: '';
    }
    .ss-svpply:before,
    .ss-svpply.right:after {
        content: '';
    }
    .ss-readmill:before,
    .ss-readmill.right:after {
        content: '';
    }
    .ss-dropbox:before,
    .ss-dropbox.right:after {
        content: '';
    }
    .ss-pinboard:before,
    .ss-pinboard.right:after {
        content: '';
    }
    .ss-dribbble:before,
    .ss-dribbble.right:after {
        content: '';
    }
    .ss-behance:before,
    .ss-behance.right:after {
        content: '';
    }
    .ss-github:before,
    .ss-github.right:after {
        content: '';
    }
    .ss-octocat:before,
    .ss-octocat.right:after {
        content: '';
    }
    .ss-stackoverflow:before,
    .ss-stackoverflow.right:after {
        content: '';
    }
    .ss-paypal:before,
    .ss-paypal.right:after {
        content: '';
    }
    .ss-kickstarter:before,
    .ss-kickstarter.right:after {
        content: '';
    }
    .ss-foursquare:before,
    .ss-foursquare.right:after {
        content: '';
    }
    .ss-yelp:before,
    .ss-yelp.right:after {
        content: '';
    }
    .ss-skype:before,
    .ss-skype.right:after {
        content: '';
    }
    .ss-rdio:before,
    .ss-rdio.right:after {
        content: '';
    }
    .ss-spotify:before,
    .ss-spotify.right:after {
        content: '';
    }
    .ss-lastfm:before,
    .ss-lastfm.right:after {
        content: '';
    }
    .ss-soundcloud:before,
    .ss-soundcloud.right:after {
        content: '';
    }
    .ss-mail:before,
    .ss-mail.right:after {
        content: '✉';
    }
    .ss-like:before,
    .ss-like.right:after {
        content: '👍';
    }
    .ss-rss:before,
    .ss-rss.right:after {
        content: '';
    }
    .ss-share:before,
    .ss-share.right:after {
        content: '';
    }
    .ss-apple:before,
    .ss-apple.right:after {
        content: '';
    }
    .ss-microsoft:before,
    .ss-microsoft.right:after {
        content: '';
    }
    .ss-windows:before,
    .ss-windows.right:after {
        content: '';
    }
    .ss-android:before,
    .ss-android.right:after {
        content: '';
    }
    .ss-blackberry:before,
    .ss-blackberry.right:after {
        content: '';
    }
`

export default socialIcons
